
const version = "v0";

const ApiEndPoints = {
    getCustomer: `authsvc/${version}/customers/username?id=`,
    getOrderByCustomerId: `authsvc/${version}/shipment/order/customer`,
    customerGroup: `authsvc/${version}/customers/group`,
    appData: `authsvc/${version}/app/data`,
    dataUsage: `authsvc/${version}/cdr/data/usage/customer/overall`,
    currentDataUsage: `authsvc/${version}/cdr/data/usage/customer/current`,
    getBill: `authsvc/${version}/billing/customer`,
    billCustomize: `authsvc/${version}/billing/customize/invoices`,
    orderHistory: `authsvc/${version}/history/customer`,
    userPlans: `authsvc/${version}/customer/plan`,
    billForecast: `authsvc/${version}/billing/forecast/customer`,
    eligiblePayLater: `authsvc/${version}/promisetopay/eligible`,
    billPay: `authsvc/${version}/payment/customer`,
    emailBill: `authsvc/${version}/customer/send`,
    config: `authsvc/${version}/config/info`,
    activation: `authsvc/${version}/activation`,
    activationStatus: `authsvc/${version}/activation/status`,
    customerOperationStatus: `authsvc/${version}/customer/operations/status`,
    topUpGroup: `authsvc/${version}/topup/group`,
    reachPlans: `authsvc/${version}/reachplans/active`,
    dataCutOff: `authsvc/${version}/data/cutoff/manage`,
    topUp: `authsvc/${version}/auto/topup/update`,
    topUpPulse: `authsvc/${version}/topup/pulse`,
    activationPreCheck: `authsvc/${version}/customer/activation/journey/precheck`,
    getCredit: `authsvc/${version}/coupon/referral/analytics/group`,
    type4Tax: `authsvc/${version}/taxes/usa`,
    topUpCustomer: `authsvc/${version}/topup/customer`,
    referalCredit: `authsvc/${version}/config/keys`,
    changePlan: `authsvc/${version}/reachplan/change`,
    otp: `authsvc/${version}/verify/security/action`,
    accStatus: `authsvc/${version}/security/action`,
    getUsageDR: `authsvc/${version}/dr/cdr/monthly/usage/group`,
    getUsageIR: `authsvc/${version}/ir/cdr/monthly/usage/group`,
    getStatusIRILDDR: `authsvc/${version}/service/status`,
    coveragePlans: `authsvc/${version}/mdn/zipcode/availability`,
    getInTouch: `authsvc/${version}/customers/hubspot`,
    toggleIRILDDR: `authsvc/${version}/manage/services`,
    getUsageILD: `authsvc/${version}/ild/usage`,
    shippmentOrder: `authsvc/${version}/shipment/order`,
    checkEmailAvailability: `authsvc/${version}/customers/availability`,
    updateCustomerSource: `authsvc/${version}/update/fields/customer`,
    updateCustomer: `authsvc/${version}/customers`,
    compatibility: `authsvc/${version}/imei/info`,
    imei: `authsvc/${version}/imei`,
    coupon: `authsvc/${version}/coupon`,
    resetPassword:`authsvc/${version}/customer/reset/password/link/email`,
    trackOrdertrackOrderByCustomerID: `authsvc/${version}/shipment/order/customer`,
    trackOrder: `authsvc/${version}/shipment/order`,
    referal: `authsvc/${version}/customer/referral/extension`,
    reachPlan:`authsvc/${version}/reachplans`,
    port: `authsvc/${version}/port/validate`,
    portResult: `authsvc/${version}/port/validate/result`
};

export default ApiEndPoints;
